export default __webpack_public_path__ + "static/media/key.115cbb62.png";